// Vendor
import * as React from 'react';
import { BarItemProps } from '@nivo/bar';
import {
  SPOT_GREY_2,
  SPOT_GREY_7,
  SPOT_WHITE
} from '@thredup/styleguide/src/variables/colors';

const Circle: React.FC<BarItemProps> = (props) => {
  const { data, color, height } = props;
  const { indexValue, value } = data;
  const radius = Math.sqrt(Math.abs(height) / Math.PI) * 15;
  const isTradThrift = indexValue === 'Traditional Thrift & Donation';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const yPositions: any = {
    'All Retail Clothing': 377,
    Resale: 140,
    'Traditional Thrift & Donation': 250
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const xPositions: any = {
    'All Retail Clothing': 76,
    Resale: 726,
    'Traditional Thrift & Donation': 376
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const linePositions: any = {
    'All Retail Clothing': radius - 65,
    Resale: radius + 35,
    'Traditional Thrift & Donation': radius + 34
  };

  const xPos = xPositions[indexValue];
  const yPos = yPositions[indexValue];
  const yPosLin = linePositions[indexValue];

  return (
    <g transform={`translate(${xPos}, ${yPos})`}>
      <text
        className="text-sm"
        dominantBaseline="central"
        fill={SPOT_GREY_7}
        textAnchor="middle"
        x="0"
        y={radius * -1 - 15}
      >
        {indexValue}
      </text>
      <line x1={0} y1={0} x2={0} y2={yPosLin} stroke={SPOT_GREY_2} />
      <circle cx={0} cy={0} r={radius} fill={color} />
      <text
        className="font-bold text-sm"
        dominantBaseline="central"
        fill={isTradThrift ? SPOT_WHITE : SPOT_GREY_7}
        textAnchor="middle"
        x={0}
        y={0}
      >
        {`${value}%`}
      </text>
    </g>
  );
};

export { Circle };
